var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google",
    clipPath: "url(#clip0_1_55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3565 6.59305C15.4474 7.11659 15.4928 7.64703 15.492 8.1784C15.492 10.5516 14.6437 12.5581 13.1676 13.9163H13.1695C11.8786 15.1087 10.1041 15.799 8.00009 15.799C5.93141 15.799 3.94744 14.9772 2.48466 13.5144C1.02188 12.0517 0.200094 10.0677 0.200094 7.999C0.200094 5.93031 1.02188 3.94635 2.48466 2.48357C3.94744 1.02078 5.93141 0.199001 8.00009 0.199001C9.93638 0.176324 11.8063 0.903763 13.2183 2.22895L10.9914 4.45585C10.1864 3.6885 9.11208 3.26829 8.00009 3.28585C5.96527 3.28585 4.23659 4.65865 3.62039 6.50725C3.29368 7.47592 3.29368 8.52501 3.62039 9.49368H3.62332C4.24244 11.3394 5.96819 12.7122 8.00302 12.7122C9.05407 12.7122 9.95692 12.4431 10.657 11.9673H10.654C11.0605 11.698 11.4082 11.3491 11.6762 10.9417C11.9441 10.5344 12.1268 10.0769 12.2131 9.59703H8.00009V6.59403H15.3565V6.59305Z",
    fill: "url(#paint0_linear_1_55)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_55",
    x1: 7.84605,
    y1: 0.198487,
    x2: 24.6676,
    y2: 12.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB0786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#8F0BAC",
    stopOpacity: 0.784646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#1118C4",
    stopOpacity: 0.489583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB0786",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6,
    height: 15.6,
    fill: "white",
    transform: "translate(0.200145 0.199707)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.9d9c0676861b35ada58cc9fcb2253cad.svg";
export { ForwardRef as ReactComponent };